import React from 'react';
import type { Language } from '../../../types/common';
import type { QaAdditional } from '../../../types/qa';

interface QaItemAdditionalProps {
  language: Language;
  additional: QaAdditional[];
}

const QaItemAdditional = ({ language, additional }: QaItemAdditionalProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log();
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {additional.map((info, idx) => (
        <div className="additional-info" key={'additional-info-' + idx}>
          {info.title && <h5>{info.title[language]}</h5>}
          <p className="mt-4 mb-0">{info.description[language]}</p>
          {info.type === 'link' ? (
            <>
              <a href={info.link} target="_blank" rel="noreferrer">
                {info.linkText}
              </a>
            </>
          ) : info.type === 'img' ? (
            <>
              <img src={process.env.PUBLIC_URL + info.imgPath} alt={info.imgAlt} />
            </>
          ) : (
            <></>
          )}
        </div>
      ))}
    </>
  );
};

export default QaItemAdditional;
